import HelpTwoToneIcon from '@mui/icons-material/HelpTwoTone'
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined'
import SupportAgentIcon from '@mui/icons-material/SupportAgent'
import {show as showIntercom} from '@intercom/messenger-js-sdk'
import {Box, IconButton, ListItemIcon, Menu, MenuItem, Tooltip} from '@mui/material'
import type {FC, MouseEvent, ReactElement} from 'react'
import {useCallback, useState} from 'react'
import {useCustomTranslation} from '@shared/hooks/useCustomTranslation.ts'

const HelpItem: FC = (): ReactElement => {
  const [t] = useCustomTranslation('common')
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const isMenuOpen = Boolean(anchorEl)

  const handleOpenMenu = useCallback((event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }, [])

  const handleCloseMenu = useCallback(() => {
    setAnchorEl(null)
  }, [])

  const handleOpenIntercom = useCallback(() => {
    handleCloseMenu()
    showIntercom()
  }, [handleCloseMenu])

  return (
    <Box id="mbai-appbar-help-item" data-testid="mbai-main-help-item-component">
      <Tooltip title={t('appbar.support_menu')} arrow>
        <IconButton
          onClick={handleOpenMenu}
          data-testid="mbai-appbar-support-menu-button"
          data-cy="mbai-appbar-support-menu-button"
        >
          <ForumOutlinedIcon />
        </IconButton>
      </Tooltip>
      <Menu
        id="mbai-appbar-support-menu"
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={handleCloseMenu}
        anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
        transformOrigin={{vertical: 'top', horizontal: 'right'}}
      >
        <MenuItem
          component="a"
          href="https://support.montblanc.ai/en/"
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleCloseMenu}
        >
          <ListItemIcon>
            <HelpTwoToneIcon fontSize="small" />
          </ListItemIcon>
          {t('appbar.help_item')}
        </MenuItem>
        <MenuItem onClick={handleOpenIntercom}>
          <ListItemIcon>
            <SupportAgentIcon fontSize="small" />
          </ListItemIcon>
          {t('appbar.contact_support')}
        </MenuItem>
      </Menu>
    </Box>
  )
}

export default HelpItem
